import React,{ useState, useEffect }  from 'react'

function WayStar({payerList,wayStarDetails,onDataChange}) {
  const [tableData, setTableData] = useState({});
  
  
  useEffect(() => {
    if (Array.isArray(wayStarDetails)) {
      const payerArray = {};
      wayStarDetails.forEach((val) => {
        const payerId = val.id;
        if (!payerArray[payerId]) {
          payerArray[payerId + '_' + 'billing_payer_id'] = val?.billing_payer_id;
          payerArray[payerId + '_' + 'tax_id'] = val?.taxId;
          payerArray[payerId + '_' + 'npi'] = val?.NPI;
        }
      });
      setTableData(payerArray);
    }
  }, [wayStarDetails]);
//{console.log('myArray',payerArray);}
  // Allowed: letters, numbers, spaces. No special characters.
  const stripSpecialChars = (v) => (v ?? "").toString().replace(/[^A-Za-z0-9 ]/g, "");

  const handleInputChange = (index, field, value) => {
    const nextValue = stripSpecialChars(value);
    let newData = [...payerList];
    newData[index][field] = nextValue;
    //setTableData(newData);
    console.log('newData',newData);
    onDataChange(newData);
  };
  //{console.log('payerList,',tableData)}
  return (
    <div>
      
      <table className="table" border={1}>
        <thead>
          <tr style={{textAlign:'center'}}>
           <th>Payer Name</th>
            <th>Payer ID</th>
            <th>Tax ID</th>
            <th>NPI</th>
          </tr>
        </thead>
        <tbody>
          {payerList.map((row, index) => (
            <tr key={row.id}>
              <td>{row.payer_name}</td>
              <td>
                <input
                  type="text"
                  defaultValue={tableData[row.id + '_' + 'billing_payer_id']}
                  onChange={(e) => {
                    const v = stripSpecialChars(e.target.value);
                    if (e.target.value !== v) e.target.value = v;
                    handleInputChange(index, 'billing_payer_id', v);
                  }}
                  className="form-control"
                />
              </td>
              <td>
                <input
                  type="text"
                  defaultValue={tableData[row.id + '_' + 'tax_id']}
                  onChange={(e) => {
                    const v = stripSpecialChars(e.target.value);
                    if (e.target.value !== v) e.target.value = v;
                    handleInputChange(index, 'taxId', v);
                  }}
                  className="form-control"
                />
              </td>
              <td>
                <input
                  type="text"
                  defaultValue={tableData[row.id + '_' + 'npi']}
                  onChange={(e) => {
                    const v = stripSpecialChars(e.target.value);
                    if (e.target.value !== v) e.target.value = v;
                    handleInputChange(index, 'NPI', v);
                  }}
                  className="form-control"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default WayStar